export default __webpack_public_path__ + "static/media/icn_refresh.612f6d14.svg";